import { render, staticRenderFns } from "./AddVehicle.vue?vue&type=template&id=e5352a24&scoped=true"
import script from "./AddVehicle.vue?vue&type=script&lang=js"
export * from "./AddVehicle.vue?vue&type=script&lang=js"
import style0 from "./AddVehicle.vue?vue&type=style&index=0&id=e5352a24&prod&scoped=true&lang=css"
import style1 from "./AddVehicle.vue?vue&type=style&index=1&id=e5352a24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5352a24",
  null
  
)

export default component.exports